import HttpClienteSeguroClass from "../../Servicios/HttpClienteSeguroClass";

// Se encacarga de listar cliente
export const listarGnlCustomer = (paginador) => {
  return new Promise((resolve, reject) => {
    HttpClienteSeguroClass.post("/GnlCustomer/Listado", paginador).then(
      (response) => {
        resolve(response);
      },
    );
  });
};

// Se usa para obtener un cliente por su id
export const obtenerGnlCustomer = (IdCliente, withCustomFields = false) => {
  const url = withCustomFields
    ? `/GnlCustomer/${IdCliente}?withCustomFields=true`
    : `/GnlCustomer/${IdCliente}`;
  return new Promise((resolve, reject) => {
    HttpClienteSeguroClass.get(url)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

export const obtenerGnlCustomerV2 = (IdCliente) => {
  return new Promise((resolve, reject) => {
    HttpClienteSeguroClass.get("/GnlCustomer/" + IdCliente)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

// metodo para crear nuevo cliente
export const crearGnlCustomer = (cliente) => {
  return new Promise((resolve, reject) => {
    HttpClienteSeguroClass.post("/GnlCustomer/Crear/", cliente)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

// Se encacarga de la actualizacion de un cliente
export const actualizarGnlCustomer = (IdCliente, cliente) => {
  return new Promise((resolve, reject) => {
    HttpClienteSeguroClass.put("/GnlCustomer/" + IdCliente, cliente)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

// Se usa para eliminar un cliente por su id
export const eliminarGnlCustomer = (registro) => {
  return new Promise((resolve, reject) => {
    HttpClienteSeguroClass.post("/GnlCustomer/Eliminar/", registro)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

// Se usa para validar una identificacion con un proveedor de verificacion de identidad
export const ValidarIdentificacion = (data) => {
  return new Promise((resolve, reject) => {
    HttpClienteSeguroClass.post("/GnlCustomer/ValidarIdentificacion/", data)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

export default listarGnlCustomer;
